import React, { useEffect, useState } from "react";
import Link from "next/link";
import { api } from "@/api/api";
import HeadTag from "@/components/HeadTag/HeadTag";

export async function getStaticProps() {
  return {
    props: { notFound: true },
  };
}

const Custom404 = () => {
  const [headerData, setHeaderData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchHeaderData = async () => {
      try {
        setIsLoading(true);
        const responseHeader = await fetch(api + "/header");
        const dataHeader = await responseHeader.json();
        setHeaderData(dataHeader);
      } catch (error) {
        console.error("Error fetching header data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHeaderData();
  }, []);

  return (
    <>
      <HeadTag
        title={"404 Page Not Found"}
        description={"404 Page Not Found"}
      />
      <div className="flex items-center justify-center flex-col text-center py-32">
        <h1 className="text-5xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-6">
          Üzgünüz, aradığınız sayfa bulunamadı.
        </p>
        <div className="grid grid-cols-3 gap-2">
          <Link
            href="/"
            className="px-4 py-2 rounded text-orange-500 font-medium"
          >
            Ana sayfa
          </Link>
          {!isLoading &&
            headerData &&
            Array.isArray(headerData.navMenu) &&
            headerData.navMenu.map((item) => (
              <Link
                key={item.id}
                href={item.url || "#"}
                className="px-4 py-2 rounded text-themeSecondColor font-medium"
              >
                {item.baslik}
              </Link>
            ))}
        </div>
      </div>
    </>
  );
};

export default Custom404;
